import { FC } from 'react';
import { ListItem, ListSubheader, Menu, Typography } from '@mui/material';

import { OperationItem } from './OperationItem';
import type { Operation } from './types';

interface OperationsMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  operations: Operation[];
}

export const OperationsMenu: FC<OperationsMenuProps> = ({ anchorEl, open, onClose, operations }) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{ sx: { minWidth: 320 } }}
    >
      <ListSubheader component="div" disableSticky disableGutters sx={{ py: 0.5, px: 1.5, lineHeight: 1.3 }}>
        <Typography variant="caption" fontWeight={600} sx={{ fontSize: 11 }}>
          Běžící operace
        </Typography>
      </ListSubheader>
      {operations.length === 0 ? (
        <ListItem button={false} sx={{ justifyContent: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Žádné běžící operace
          </Typography>
        </ListItem>
      ) : (
        operations.map((operation, index) => (
          <OperationItem key={operation.id} operation={operation} divider={index < operations.length - 1} />
        ))
      )}
    </Menu>
  );
};
